<script>
import {mapActions} from "vuex";
import PrefectureList from '../../../../../mixins/PrefectureList'
import ZipCodeSearch from "../../../../../components/ZipCodeSearch.vue";
import SearchZipModal from "../../../../components/SearchZipModal.vue";

export default {
  name: "LocationFormModal",
  components: {
    ZipCodeSearch,
    SearchZipModal
  },
  mixins: [PrefectureList],
  props: {
    enableModal: {
      type: Boolean,
      default: () => false,
    },
    traderId: {
      type: [String, Number],
      default: () => null,
    },
    locationId: {
      type: Number,
      default: () => null,
    },
  },
  data () {
    return {
      form: {},
      generalWasteDisposal: null,
      enableSearchZipModal: false,
    }
  },
  watch: {
    enableModal (value) {
      this.$nextTick(() => this.$refs.observer.reset());
      Object.assign(this.$data.form, this.$options.data().form);
      this.scrollToTop();
      if (value) {
        this.loadTrader();
        this.load();
      }
    },
  },
  computed: {},
  created () {},
  methods: {
    ...mapActions("DriverMasterGeneralWasteDisposal", {
      fetchGeneralWasteDisposal: "show",
    }),
    ...mapActions("DriverMasterGeneralWasteDisposalLocation", {
      fetchNewLocation: "new",
      fetchEditLocation: "edit",
      storeLocation: "create",
      updateLocation: "update",
    }),
    searchZipButtonClickEvent () {
      this.enableSearchZipModal = true;
    },
    /**
     * 一般廃棄物処分業者情報をコピーボタン クリックイベント
     */
    copyButtonClickEvent () {
      this.form.name = this.generalWasteDisposal.name
      this.form.zip_code = this.generalWasteDisposal.zip_code
      this.form.prefecture_code = this.generalWasteDisposal.prefecture_code
      this.form.address_1 = this.generalWasteDisposal.address_1
      this.form.address_2 = this.generalWasteDisposal.address_2
      this.form.address_3 = this.generalWasteDisposal.address_3
      this.form.phone_number = this.generalWasteDisposal.phone_number
    },

    closeButtonClickEvent () {
      this.$emit("closeCallback")
    },

    registerButtonClickEvent () {
      this.$refs.observer.validate().then((success) => {
        console.log("success:", success)
        if (success) {
          if (this.locationId) {
            this.update();
          } else {
            this.store();
          }
        }
      })
    },

    load () {
      if (this.locationId) {
        this.fetchEditLocation({ trader_id: this.traderId, id: this.locationId }).then((content) => {
          this.form = content
        })
      } else {
        this.fetchNewLocation({ trader_id: this.traderId }).then((content) => {
          this.form = content
        })
      }
    },

    loadTrader () {
      this.fetchGeneralWasteDisposal({ id: this.traderId }).then((content) => {
        this.generalWasteDisposal = content;
      })
    },

    store () {
      this.storeLocation({ trader_id: this.traderId, params: this.form }).then(() => {
        this.$emit("registerCallback")
      })
    },

    update () {
      this.updateLocation({ trader_id: this.traderId, id: this.locationId, params: this.form }).then(() => {
        this.$emit("registerCallback")
      })
    },

    /**
     * 郵便番号検索 コールバック
     * @param content
     */
    zipAddressCallback (content) {
      this.form.prefecture_code = `${content.pref_code}`
      this.form.address_1 = `${content.locality}`
      this.form.address_2 = `${content.street}`
    },
    scrollToTop() {
      const elements = document.getElementsByClassName('v-dialog--active')
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      const cards = elements[0].getElementsByClassName('card-layer')
      if (!cards || !cards.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      cards[0].scrollTop = 0;
    },
    closeModalCallback () {
      this.enableSearchZipModal = false;
    },
    /**
     * 郵便番号検索反映ボタン コールバック
     * @param address { Object }
     * @property address.zip_code { string } 郵便番号
     * @property address.prefecture_code { number } 都道府県コード
     * @property address.city { string } 市区町村
     * @property address.town { string } 町域
     */
    searchZipReflectCallback (address) {
      this.form.zip_code = address.zip_code
      this.form.prefecture_code = `${address.prefecture_code}`
      this.form.address_1 = address.city
      this.form.address_2 = address.town
    },
    searchZipReflectZipCallback (zipCode) {
      this.form.zip_code = zipCode;
    },
  },

}
</script>

<template>
  <v-dialog
    :value="enableModal"
    persistent
    width="800"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer ref="observer">
      <v-card v-if="form">
        <v-toolbar flat>
          <v-toolbar-title>事業場設定</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="card-layer pt-2" style="max-height: 60vh;overflow-y: auto">
          <v-row dense>
            <v-col class="text-right">
              <v-btn
                class="primary"
                @click="copyButtonClickEvent"
              >
                一般廃棄物処分業者情報をコピー
              </v-btn>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="事業場コード"
                rules="required|alpha_num_only|max:10"
              >
                <v-text-field
                  v-model="form.code"
                  :error-messages="errors"
                  :disabled="!!locationId"
                  dense
                  hide-details="auto"
                  label="事業場コード"
                  hint="半角英数字のみ10文字以内"
                  outlined
                  persistent-hint
                  persistent-placeholder
                  placeholder="例）NL01"
                >
                  <template v-slot:label>
                    <span>事業場コード</span>
                    <span class="ml-1">
                      ({{ form.code?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="事業場名"
                rules="required|max:60"
              >
                <v-text-field
                  v-model="form.name"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="事業場名"
                  outlined
                  persistent-placeholder
                  placeholder="例）△△△△　株式会社"
                >
                  <template v-slot:label>
                    <span>事業場名</span>
                    <span class="ml-1">
                      ({{ form.name?.length || 0 }} / 60)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" md="9">
              <validation-provider
                v-slot="{ errors }"
                :rules="{zip_code: true, required: true, max:8 }"
                class="requiredMark"
                name="郵便番号"
              >
                <v-text-field
                  v-model="form.zip_code"
                  :error-messages="errors"
                  dense
                  label="郵便番号"
                  hide-details="auto"
                  hint="ハイフンを含めて入力してください"
                  outlined
                  persistent-hint
                  persistent-placeholder
                  placeholder="例）111-1111"
                  required
                >
                  <template v-slot:label>
                    <span>郵便番号</span>
                    <span class="ml-1">
                      ({{ form.zip_code?.length || 0 }} / 8)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                  <template v-slot:append-outer>
                    <zip-code-search
                      :zip-code="form.zip_code"
                      @zipAddress="zipAddressCallback"
                    />
                    &nbsp;
                    <v-btn
                      outlined
                      small
                      @click="searchZipButtonClickEvent"
                    >
                      住所→郵便番号
                    </v-btn>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /郵便番号 -->

          <!-- 都道府県／市区町村 -->
          <v-row dense>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="都道府県"
                rules="required"
              >
                <v-autocomplete
                  v-model="form.prefecture_code"
                  :error-messages="errors"
                  :items="prefList"
                  dense
                  hide-details="auto"
                  item-text="text"
                  item-value="value"
                  label="都道府県"
                  outlined
                  persistent-placeholder
                  placeholder="例）東京都"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6">
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="市区町村"
                rules="required|full_width|max:20"
              >
                <v-text-field
                  v-model="form.address_1"
                  :error-messages="errors"
                  dense
                  label="市区町村"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）中央区"
                >
                  <template v-slot:label>
                    <span>市区町村</span>
                    <span class="ml-1">
                      ({{ form.address_1?.length || 0 }} / 20)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /都道府県／市区町村 -->

          <!-- 町域 -->
          <v-row dense>
            <v-col cols="12" md="10">
              <validation-provider
                v-slot="{ errors }"
                name="町域"
                rules="full_width|max:40"
              >
                <v-text-field
                  v-model="form.address_2"
                  :error-messages="errors"
                  dense
                  label="町域"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）日本橋兜町"
                >
                  <template v-slot:label>
                    <span>町域</span>
                    <span class="ml-1">
                      ({{ form.address_2?.length || 0 }} / 40)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /町域 -->
          <!-- 詳細住所 -->
          <v-row dense>
            <v-col cols="12" md="10">
              <validation-provider
                v-slot="{ errors }"
                name="詳細住所"
                rules="max:50"
              >
                <v-text-field
                  v-model="form.address_3"
                  :error-messages="errors"
                  dense
                  label="詳細住所"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）１−２−３　○○ビル○階"
                >
                  <template v-slot:label>
                    <span>詳細住所</span>
                    <span class="ml-1">
                      ({{ form.address_3?.length || 0 }} / 50)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /詳細住所 -->

          <!-- 電話番号 -->
          <v-row dense>
            <v-col cols="12" md="6">
              <validation-provider
                v-slot="{ errors }"
                name="電話番号"
                :rules="{ numeric_hyphen_only: true,min: 2, max: 15 }"
              >
                <v-text-field
                  v-model="form.phone_number"
                  :error-messages="errors"
                  dense
                  label="電話番号"
                  hint="電話番号を「-」ハイフン「( )」込みで入力します"
                  persistent-hint
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）000-0000-0000"
                >
                  <template v-slot:label>
                    <span>電話番号</span>
                    <span class="ml-1">
                      ({{ form.phone_number?.length || 0 }} / 15)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /電話番号 -->
          <!-- 事業場区分 -->
          <v-row dense>
            <v-col cols="12" md="8">
              <v-radio-group
                v-model="form.location_type"
                label="事業場区分"
                row
                dense
                hide-details="auto"
                class="pa-0 ma-0"
              >
                <v-radio
                  v-if="generalWasteDisposal.subscriber_type === 'transport_type'"
                  label="積替・保管"
                  value="transshipment"
                />
                <v-radio
                  v-if="generalWasteDisposal.subscriber_type === 'disposer_type'"
                  label="中間処理のみ"
                  value="only_middle"
                />
                <v-radio
                  v-if="generalWasteDisposal.subscriber_type === 'disposer_type'"
                  label="最終処分のみ"
                  value="only_last"
                />
                <v-radio
                  v-if="generalWasteDisposal.subscriber_type === 'disposer_type'"
                  label="中間処理＋最終処分"
                  value="middle_and_last"
                />
              </v-radio-group>
            </v-col>
          </v-row>

        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
    <search-zip-modal
      :enable="enableSearchZipModal"
      :initial-prefecture-code="form.prefecture_code"
      :initial-city-name="form.address_1"
      :initial-town-name="form.address_2"
      @reflectFullCallback="searchZipReflectCallback"
      @reflectZipCallback="searchZipReflectZipCallback"
      @closeCallback="closeModalCallback"
    />
  </v-dialog>
</template>

<style scoped lang="scss">

</style>
